import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { Building, CreateBuildingDto, UpdateBuildingDto } from "./data-contracts";

export const buildingControllerCreate = (data: CreateBuildingDto, params?: IFetchConfig) =>
  fetch<Building>("POST", `building`, data, params);

export const buildingControllerFindAll = (
  query?: {
    groupId?: number,
  },
  params?: IFetchConfig
) => fetch<Building[]>("GET", `building`, query, params);

export const buildingControllerFindOne = (id: number, params?: IFetchConfig) =>
  fetch<Building[]>("GET", `building/${id}`, null, params);

export const buildingControllerUpdate = (id: number, data: UpdateBuildingDto, params?: IFetchConfig) =>
  fetch<Building>("PUT", `building/${id}`, data, params);

export const buildingControllerRemove = (id: number, params?: IFetchConfig) =>
  fetch<void>("DELETE", `building/${id}`, null, params);
